<template>
  <control :label="$t('birthday')" :showClear="modelValue" @clear="handleClear" :warning="warning">
    <div class="birthday-conatiner">
      <month-picker
        class="picker"
        :value="month"
        @input="(value) => handleSave({ value, name: 'month' })"
      />
      <year-picker
        class="picker"
        :value="year"
        @input="(value) => handleSave({ value, name: 'year' })"
      />
      <age-limit-modal :visible="visible" @cancel="handleCancel" />
    </div>
  </control>
</template>

<script>
import moment from 'moment';
import { SECTION_CODES } from '@/constants';
import updateMixin from '@/components/account/targetingInfo/updateMixin';
import { isAdult } from '@/services/datetime';
import { decodeAgeRange } from '@/services/targetingInfo/transformers';
import Control from '@/components/account/targetingInfo/Control.vue';
import MonthPicker from './MonthPicker.vue';
import YearPicker from './YearPicker.vue';
import AgeLimitModal from './AgeLimitModal.vue';

export default {
  components: {
    Control,
    MonthPicker,
    YearPicker,
    AgeLimitModal,
  },
  mixins: [updateMixin(SECTION_CODES.AGE_RANGE)],
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    month() {
      return this.getMonth();
    },
    year() {
      return this.getYear();
    },
  },
  methods: {
    handleCancel() {
      this.visible = false;
    },
    async handleSave({ name, value }) {
      const month = name === 'month' ? value : this.month || 0;
      const year = name === 'year' ? value : this.year || 2000;

      const date = moment().set('month', month).set('year', year);

      if (!isAdult(date)) {
        this.visible = true;
        return;
      }

      const formattedDate = date.locale('en').format('MMM, YYYY');
      await this.onValueChange(formattedDate);
    },
    handleClear() {
      this.onClear();
    },
    getYear() {
      const { year } = decodeAgeRange(this.modelValue || '');
      return this.modelValue && Number(year);
    },
    getMonth() {
      const { month } = decodeAgeRange(this.modelValue || '');
      moment.locale('en');
      return this.modelValue && moment.monthsShort().indexOf(month);
    },
  },
};
</script>

<style lang="scss" scoped>
.birthday-conatiner {
  display: flex;
  margin-left: -5px;
}
.picker {
  padding: 0 5px;
}
</style>
